import { controls, currencyToNumber, grouped } from "../../controls";

const rp101m = {
  label: "Monthly Financial Position",
  starting: true,
  url: "rp101m",
  pageLabel: "Monthly Financial Position",
  pageType: "history",
  // filteraction: true,
  filter: [
    ...controls.magicDateLabel({ tab: "filter", label: "As On Date", width: "col-sm-2", target: "as_on_date" }),
    ...controls.magicDate({ tab: "filter", name: "as_on_date", width: "col-sm-2", dateType: "ontype", default: "lqe" }),
  ],
  form: [],
  history: {
    perPage: 50,
    reportHeader: "Monthly Financial Position",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A3", pageOrientation: "landscape" },
    textReportProps: {
      'Recon': {
        filename: `Monthly Financial Position-$pageData.as_on_date$.txt`,
        format: {},
        separator: "|"
      },
    },
    pivotable: true,
    charts: {
      pie: {
        row: { targetfield: 'all_total', flabel: 'group_display' },
        column: { targetrow: 'grand_total' },
      }
    },
    extraRows: {
      location: "bottom",
      fields: ["amount"],
      subtotals: {
        by: "parent",
        displayIn: "group_display",
        labels: {
          share: "Share Total", type2: "Total", type3: "Total"
        },
      },
      grandtotal: { type: "fixed", displayIn: "group_display", val: "Grand Total", count: true },
    },
    displayColumns: [
      {
        Header: "Sr", type: "autoinc", accessor: "srno", align: "center", width: 30,
        width132: { size: 3 }
      },
      {
        Header: "Particulars",
        accessor: "group_display",
        rwidth: "*"
      },
      {
        Header: "Ambala",
        accessor: "amount",
        type: "currency",
        fontSize: (d) => (d['group_display'] == 'Branch Adjustment' && currencyToNumber(d['amount']) > 300000) ? 10 : 8,
        color: (d) => (d['group_display'] == 'Branch Adjustment' && currencyToNumber(d['amount']) > 300000) ? "white" : "black",//green 
        back: (d) => (d['group_display'] == 'Branch Adjustment' && currencyToNumber(d['amount']) > 300000) ? "gray" : "white",//green 
      },
      {
        Header: "Bhiwani",
        accessor: "bhiwani",
        type: "currency"

      },
      {
        Header: "F/Bad",
        accessor: "fbar",
        type: "currency"
      },
      {
        Header: "Ft/Bad",
        accessor: "ftbad",
        type: "currency"
      },
      {
        Header: "Gurgaon",
        accessor: "gurugaon",
        type: "currency"
      },
      {
        Header: "Hisar",
        accessor: "hisar",
        type: "currency"
      },
      {
        Header: "Jhajjar",
        accessor: "jhajjar",
        type: "currency"
      },
      {
        Header: "Jind",
        accessor: "jind",
        type: "currency"
      },
      {
        Header: "Karnal ",
        accessor: "karnal",
        type: "currency"
      },
      {
        Header: "Kaithal",
        accessor: "kaithal",
        type: "currency"
      },
      {
        Header: "K/shetra",
        accessor: "kshetra",
        type: "currency"
      },
      {
        Header: "M/garh",
        accessor: "mgarh",
        type: "currency"
      },
      {
        Header: "Panipat",
        accessor: "panipat",
        type: "currency"
      },
      {
        Header: "Rewari",
        accessor: "rewari",
        type: "currency"
      },
      {
        Header: "Rohtak",
        accessor: "rohtak",
        type: "currency"
      },
      {
        Header: "Sirsa",
        accessor: "sirsa",
        type: "currency"
      },
      {
        Header: "Sonepat",
        accessor: "sonepat",
        type: "currency"
      },
      {
        Header: "Y/nagar",
        accessor: "ynagar",
        type: "currency"
      },
      {
        Header: "P/kula",
        accessor: "pkula",
        type: "currency"
      },
      {
        Header: "G Total",
        accessor: "all_total",
        width132: { size: 13, },
        formula: [{
          f: 'simpleArithmatic', calcType: 'sum', inputs: [
            { source: 'row', field: 'amount' }
          ], resultVar: 'total'
        }],
        type: "currency",
      }
    ]
  }
};

export default rp101m;